import React, { createContext, useContext } from 'react';
import { createFeature } from '@edreamsodigeo/frontend-core';
import {
  createItinerarySelectionJustPrime,
  createItinerarySelectionWithCheapest,
} from './createItinerarySelection';
import { SHOPPING_CART_WITH_CHEAPEST } from '../../ab/aliases';

const ShoppingCartRequestCreatorContext = createContext();

export const useShoppingCartRequestCreator = () =>
  useContext(ShoppingCartRequestCreatorContext);

const createShoppingCartRequestCreatorProvider =
  (createItinerarySelection) =>
  ({ children }) => {
    return (
      <ShoppingCartRequestCreatorContext.Provider
        value={createItinerarySelection}
      >
        {children}
      </ShoppingCartRequestCreatorContext.Provider>
    );
  };

const ShoppingCartRequestCreatorProvider = createFeature({
  name: SHOPPING_CART_WITH_CHEAPEST,
  variations: [
    createShoppingCartRequestCreatorProvider(createItinerarySelectionJustPrime),
    createShoppingCartRequestCreatorProvider(
      createItinerarySelectionWithCheapest
    ),
  ],
  version: 1,
});

export default ShoppingCartRequestCreatorProvider;
